import axios from "../utils/axios";

export const getPlants = () => {
    return axios.get(`/Plant/GetList`);
};

export const getBreakdownGroups = () => {
    return axios.get(`/BreakdownReasonGroup/GetList`);
};

export const getBreakdownReasonPlaces = () => {
    return axios.get(`/BreakdownReasonPlace/GetDetailedList`);
};

export const updateBreakdownReasonPlace = (payload) => {
    return axios.post(`/BreakdownReasonPlace/Update`, payload);
};

export const addBreakdownReasonPlace = (payload) => {
    return axios.post(`/BreakdownReasonPlace/Add`, payload);
};

export const deleteBreakdownReasonGroup = (payload) => {
    return axios.post(`/BreakdownReasonPlace/Delete`, payload);
};
